import CsatByDayOfWeekWidget from './CsatByDayOfWeekWidget';
export default CsatByDayOfWeekWidget;



// WEBPACK FOOTER //
// ./src/components/widgetTypes/components/CsatByDayOfWeekWidget/index.js